import React from 'react';
import { Select } from './ui/Select';
interface MonthSelectorProps {
  selectedMonth: string;
  onChange: (month: string) => void;
}
export function MonthSelector({
  selectedMonth,
  onChange
}: MonthSelectorProps) {
  // Generate last 6 months
  const months = Array.from({
    length: 6
  }, (_, i) => {
    const d = new Date();
    d.setMonth(d.getMonth() - i);
    return {
      value: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`,
      label: d.toLocaleString('default', {
        month: 'long',
        year: 'numeric'
      })
    };
  });
  return <div className="w-48" data-id="element-192">
      <Select options={months} value={selectedMonth} onChange={e => onChange(e.target.value)} className="font-medium" data-id="element-193" />
    </div>;
}